import React from 'react';
import { StatCard } from '../../shared/StatCard';

const LogsTab = ({ 
  sentryData, 
  sentryLoading, 
  loadSentryData,
  handleViewEventDetails,
  formatTimestamp,
  getLevelColor 
}) => {
  return (
    <div>
      <div className="flex justify-between items-center mb-4">
        <h2 className="text-xl font-bold text-gray-800">Sentry Logs & Issues</h2>
        <div className="flex space-x-2">
          <button 
            onClick={loadSentryData}
            disabled={sentryLoading}
            className="bg-blue-600 hover:bg-blue-700 disabled:bg-gray-400 text-white font-bold py-2 px-4 rounded flex items-center"
          >
            <i className={`fa-solid fa-sync-alt mr-2 ${sentryLoading ? 'animate-spin' : ''}`}></i>
            {sentryLoading ? 'Loading...' : 'Refresh'}
          </button>
        </div>
      </div>

      {/* Sentry Project Stats */}
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4 mb-6">
        <StatCard
          title="Total Issues"
          value={sentryLoading ? 'Loading...' : sentryData.projectStats.totalIssues}
          icon="fa-exclamation-triangle"
          color="red"
        />
        <StatCard
          title="Resolved"
          value={sentryLoading ? 'Loading...' : sentryData.projectStats.resolvedIssues}
          icon="fa-check-circle"
          color="green"
        />
        <StatCard
          title="Unresolved"
          value={sentryLoading ? 'Loading...' : sentryData.projectStats.unresolvedIssues}
          icon="fa-clock"
          color="yellow"
        />
        <StatCard
          title="Error Rate"
          value={sentryLoading ? 'Loading...' : sentryData.projectStats.errorRate}
          icon="fa-chart-line"
          color="purple"
        />
      </div>

      {/* Issues Table */}
      <div className="bg-white border rounded-lg p-4">
        <h3 className="text-lg font-semibold text-gray-800 mb-4">Active Issues</h3>
        <div className="overflow-x-auto">
          <table className="min-w-full divide-y divide-gray-200">
            <thead className="bg-gray-50">
              <tr>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                  Issue
                </th>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                  Platform
                </th>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                  Level
                </th>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                  Count
                </th>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                  Users
                </th>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                  Last Seen
                </th>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                  Actions
                </th>
              </tr>
            </thead>
            <tbody className="bg-white divide-y divide-gray-200">
              {sentryData.issues.map((issue) => (
                <tr key={issue.id}>
                  <td className="px-6 py-4 text-sm text-gray-900">
                    <div className="max-w-xs">
                      <div className="font-medium">{issue.title}</div>
                      <div className="text-xs text-gray-500">{issue.metadata?.filename}</div>
                    </div>
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
                    {issue.metadata?.sdk?.name === 'sentry.javascript.react' ? 'FrontEnd React' : 'Azure Function'}
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap">
                    <span className={`px-2 inline-flex text-xs leading-5 font-semibold rounded-full ${getLevelColor(issue.level)}`}>
                      {issue.level}
                    </span>
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
                    {issue.count}
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
                    {issue.userCount}
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
                    {formatTimestamp(issue.lastSeen)}
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap text-sm font-medium">
                    <div className="flex space-x-2">
                      <a 
                        href={issue.permalink} 
                        target="_blank" 
                        rel="noopener noreferrer"
                        className="text-blue-600 hover:text-blue-900"
                      >
                        <i className="fa-solid fa-external-link-alt"></i>
                      </a>
                      <button className="text-green-600 hover:text-green-900">
                        <i className="fa-solid fa-check"></i>
                      </button>
                      <button className="text-gray-600 hover:text-gray-900">
                        <i className="fa-solid fa-ban"></i>
                      </button>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

export default LogsTab; 